import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { LocalStorageService } from '../services';
import { ROUTES } from '../constants';
import { StorageService } from '../services/storage.service';

export const AuthorizationGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  // const isAuthorized = inject(StorageService).getToken() ? true : false
  const isAuthorized = inject(StorageService).getUserInformation() ? true : false
  // const isAuthorized = inject(LocalStorageService).getDataInLocalStorage('token') ? true : false
  if (next.routeConfig?.path === 'profile-completion/:id' || next.routeConfig?.path === 'profile-completion') { 
    localStorage.setItem('redirectionUrl', state.url); 
  }
  console.log("isAuthorized ==========> ", isAuthorized);
  !isAuthorized ? inject(Router).navigateByUrl(ROUTES.login) : false
  return true
};

